export default __webpack_public_path__ + "media/zurb/img/home/SAP-2fce83da211f372e7e13febe98b99d13.png";